import React from "react";
import { Alert, Box, Button } from "@mui/material";
import { useIntl } from "react-intl";
import RevaText from "components/common/RevaText";
import { useGestionCustomer } from "hooks/useGestionCustomer";
import { revaAdminBillingSummaryUrl } from "utils/revaAdminBillingUrl";
import { formatSubscriptionStatus } from "utils/formatSubscriptionStatus";

/**
 * Blocks Gestión content when the customer's Fansbury subscription is unpaid.
 * System admins receive gestion_access "full" from the API and skip this page.
 */
const GestionSubscriptionGate = ({ children }) => {
  const intl = useIntl();
  const { customer } = useGestionCustomer();

  if (!customer || customer.gestion_access !== "payment_required") {
    return children;
  }

  const billingUrl = revaAdminBillingSummaryUrl();

  return (
    <Box sx={{ width: "100%", maxWidth: 640, mx: "auto", p: { xs: 3, md: 4 } }}>
      <RevaText variant="h4" sx={{ mb: 2 }}>
        {intl.formatMessage({ id: "gestion.paymentRequired.title" })}
      </RevaText>
      <Alert severity="warning" sx={{ mb: 3 }}>
        {intl.formatMessage(
          { id: "gestion.paymentRequired.body" },
          {
            name: customer.name,
            status: formatSubscriptionStatus(intl, customer.subscription_status || "unpaid"),
          }
        )}
      </Alert>
      <RevaText variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        {intl.formatMessage({ id: "gestion.paymentRequired.hint" })}
      </RevaText>
      <Button variant="contained" color="primary" href={billingUrl} component="a">
        {intl.formatMessage({ id: "gestion.paymentRequired.cta" })}
      </Button>
    </Box>
  );
};

export default GestionSubscriptionGate;
